import { Pill, PillProps } from '@mantine/core';

import { BadgeTypeStyles, BadgeTypes } from '../../DataDisplay/Badge/Badge';
import classes from './Pill.module.css';

const PillDefaults = Pill.extend({
  classNames: {
    root: classes.root,
    label: classes.label,
    remove: classes.remove,
  },
  defaultProps: {},
  styles(theme, props) {
    const type = props?.mod?.['type'] ?? 'primary';
    const typeStyles = BadgeTypeStyles(theme)[type][props.variant];

    if (type && typeStyles) {
      return {
        root: {
          '--pill-type-background-color': typeStyles.backgroundColor,
          '--pill-type-color': typeStyles.color,
        },
      };
    }
    return {
      root: {},
    };
  },
});

interface _PillProps extends PillProps {
  type?: (typeof BadgeTypes)[number];
}

const _Pill = ({ type, ...props }: _PillProps) => {
  return (
    <Pill
      mod={{
        type,
      }}
      {...props}
    />
  );
};

const __Pill = Object.assign(_Pill, Pill);

export { __Pill as Pill, PillDefaults };
